import { useEffect, type ReactElement } from 'react'
import { StationNav } from '../../components/stationPage/StationNav'

/**
 * Private QA fixture for Playwright snapshots of the station-page
 * anchor tab row (TASK-699, Figma 8597:41522).
 *
 * URL contract: /__visual/station-nav
 *
 * Light theme only — the template's dark variant has no Figma node
 * yet. `visual-fixture-active` neutralises the map SPA's JS-sized
 * absolute `#root` (see index.css).
 *
 * Dev/QA only — excluded from robots.txt (`Disallow: /__visual/`).
 */
export function StationNavVisualFixture(): ReactElement {
  useEffect(() => {
    const html = document.documentElement
    html.classList.add('visual-fixture-active')
    return () => {
      html.classList.remove('visual-fixture-active')
    }
  }, [])

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <StationNav />
    </div>
  )
}
